export function* confettiDetailsSaga() {
  //yield takeLatest(confettiDetailsAction.GetConfettiDetailsAction.type, getConfettiDetails);
}
